<template>
  <iframe frameBorder="0" :src="frameSrc" :width="containerWidth" :height="containerHeight"/>
</template>

<script>
export default {
  data () {
    return {
      containerWidth: 640,
      containerHeight: 360
    }
  },
  props: {
    frameSrc: {
      type: String,
      required: true
    },

  },
  computed: {
    /* frameSrc2 () {
      return `/#/?isMeeting=${this.isMeeting}&isSilence=${this.isSilence}`
    } */
  }
}
</script>
